import axios from 'axios'
import { isFunction as _isFunction } from 'lodash'

import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const GetOfferDetails = async (type, status, channelId, customerAccountId, customHeaders = {}, utilities = {}) => {
  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  const data = {
    params: {
      type: type,
      status: status,
      channelId: channelId,
      customerAccountId: customerAccountId
    },
    data: null,
    headers: customHeaders,
  }

  onStart()

  try {
    const response = await axios.get(API_URLS.baseUrlVFAL + API_URLS.getOfferDetails, data)

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const GetPreferences = async (partyId, channelId, offset, count, customHeaders = {}, utilities = {}) => {
  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  const data = {
    params: {
      partyId: partyId,
      channelId: channelId,
      offset: offset,
      count: count
    },
    data: null,
    headers: customHeaders
  }

  onStart()

  try {
    const response = await axios.get(API_URLS.baseUrlVFAL + API_URLS.getPreferences, data)

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const UpdatePreferences = async (id, preferences, customHeaders = {}, utilities = {}) => {
  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  preferences = JSON.stringify(preferences)
  preferences = preferences.replace(/ë/g, 'e')
  preferences = preferences.replace(/ç/g, 'c')
  preferences = preferences.replace(/Ë/g, 'c')
  preferences = preferences.replace(/Ç/g, 'c')

  preferences = JSON.parse(preferences)
  const data = {
    ...preferences
  }

  onStart()

  try {
    const response = await axios.patch(API_URLS.baseUrlVFAL + API_URLS.updatePreferences + id, data, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const SearchAccount = async (msisdn, id_card, type, email, count, limit, customHeaders = {}, utilities = {}) => {
  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  const requestBody = {
    'queryOptions': {
      'filter': '',
      'pagination': {
        'count': count,
        'limit': limit
      },
      'sorting': ''
    },
    'queries': [
      {
        'query': '$.parts.subscription.msisdn=' + msisdn
      },
      {
        'operator': 'AND'
      },
      {
        'query': '$.parts.subscription.id.value=' + id_card
      },
      {
        'operator': 'AND'
      },
      {
        'query': '$.type=' + type
      },
      {
        'operator': 'AND'
      },
      {
        'query': '$.relatedParty.contactPerson.contactPoint.email.fullAddress=' + email
      }
    ]
  }

  const data = {
    ...requestBody
  }

  onStart()

  try {
    const response = await axios.post(API_URLS.baseUrlVFAL + API_URLS.searchAccount, data, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const Notify = async (
  id,
  name,
  desc,
  category,
  status,
  details,
  campaign,
  activationPeriod,
  msisdn,
  screen,
  customHeaders = {},
  utilities = {}
) => {
  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  delete activationPeriod?.validityTimePeriod

  const requestBody = {
    'id': id,
    'name': name,
    'desc': desc,
    'type': 'pega',
    'category': category,
    'status': status,
    'details': Object.assign({}, details, { 'behaviour': 'Positive' }),
    'parts': {
      'campaign': campaign,
      'channel': [{
        'id': [{
          'value': 'myvodafone'
        }
        ]
      }
      ],
      'activationPeriod': [activationPeriod],
      'customerAccount': [{
        'id': [{
          'value': msisdn
        }
        ]
      }
      ],
      'customerInteraction': [{
        'name': screen,
        'desc': screen,
        'type': 'pega_interaction',
        'category': [{
          'value': 'pega_interaction'
        }
        ]
      }
      ]
    }
  }

  const data = {
    ...requestBody
  }

  onStart()

  try {
    const response = await axios.post(API_URLS.baseUrlVFAL + API_URLS.notify, data, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const CreateOrder = async (
  id,
  type,
  category,
  status,
  activationPeriod,
  msisdn,
  personalInfo = {},
  lineItem,
  pinCode = '',
  lastRecharges = [],
  frequentlyCalled = [],
  image = {},
  customHeaders = {},
  utilities = {}
) => {
  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  const requestBody = {
    'id': id,
    'type': type,
    'category': category,
    'status': status,
    'customerAccount': {
      'id': {
        'value': msisdn
      }
    },
    'channel': {
      'id': {
        'value': 'myvodafone'
      }
    },
    'activationDateTime': {
      'value': activationPeriod?.id?.[0]?.value,
      'format': activationPeriod?.type
    },
    'relatedParty': [
      {
        'id': msisdn,
        'individual': {
          'givenName': personalInfo?.name || '',
          'familyName': personalInfo?.familyName || '',
          'fullName': `${personalInfo?.name || ''} ${personalInfo?.familyName || ''}`,
          'individualIdentification': [
            {
              'type': 'Consumer',
              'identificationId': personalInfo?.idCard || '',
              'issuingAuthority': '',
              'issuingDate': ''
            }
          ],
          'contactMedium': [
            {
              'type': personalInfo?.accountType || '',
              'medium': {
                'streetOne': personalInfo?.address || '',
                'emailAddress': personalInfo?.emailAddress || personalInfo?.email || '',
                'type': 'Consumer',
                'number': personalInfo?.contactNumber || ''
              }
            }
          ]
        },
        'organisation': {
          'organizationIdentification': {
            'type': 'NIPT',
            'identificationId': personalInfo?.vatNumber || personalInfo?.idCard || ''
          }
        }
      }
    ],
    'lineItem': lineItem,
    'specifications': [
      {
        'name': 'Amount of last 3 Recharges',
        'desc': 'Amount of last 3 Recharges',
        'type': 'last_recharges_list',
        'category': [
          {
            'value': 'last_recharges_list'
          }
        ],
        'characteristicsValue': [
          {
            'characteristicName': 'recharge_item',
            'value': lastRecharges?.[0] || ''
          },
          {
            'characteristicName': 'recharge_item',
            'value': lastRecharges?.[1] || ''
          },
          {
            'characteristicName': 'recharge_item',
            'value': lastRecharges?.[2] || ''
          }
        ]
      },
      {
        'name': '3 most frequent numbers called',
        'desc': '3 most frequent numbers called',
        'type': 'frequent_numbers_list',
        'category': [
          {
            'value': 'frequent_numbers_list'
          }
        ],
        'characteristicsValue': [
          {
            'characteristicName': 'frequent_number_item',
            'value': frequentlyCalled?.[0] || ''
          },
          {
            'characteristicName': 'frequent_number_item',
            'value': frequentlyCalled?.[1] || ''
          },
          {
            'characteristicName': 'frequent_number_item',
            'value': frequentlyCalled?.[2] || ''
          }
        ]
      },
      {
        'name': 'Pin Verification',
        'desc': 'Pin Verification',
        'type': 'pin_verification',
        'category': [
          {
            'value': 'pin_verification'
          }
        ],
        'characteristicsValue': [
          {
            'characteristicName': 'pin',
            'value': pinCode
          }
        ]
      }
    ],
    'attachment': [
      {
        'name': 'attachment',
        'description': 'Free text',
        'binaryObject': {
          'value': image?.base64 || '',
          'format': 'base64',
          'mimeCode': 'token',
          'encodingCode': 'token',
          'characterSetCode': 'token',
          'uri': image?.uri || '',
          'fileName': image?.uri || ''
        },
        'mimeType': 'mimeType',
        'size': 4,
        'sizeUnit': 'sizeUnit',
        'url': 'url'
      }
    ]
  }

  const data = {
    ...requestBody
  }

  onStart()

  try {
    const response = await axios.post(API_URLS.baseUrlVFAL + API_URLS.createOrder, data, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

export { GetOfferDetails, GetPreferences, UpdatePreferences, SearchAccount, Notify, CreateOrder }
